import { Space } from 'antd';
import OutdoorTemperatureProgressiveChart, { DateTitle, FlippingCardComponent } from '../components/exhibitions/FlippingCardsExhibition';
import { useEffect, useState } from 'react';
import { RefSimulationSteps } from '../hooks/exhibitions/FlippingCardsExhibition';
// import * as libCon from '../community-hats-js-library/Constants.js';
import * as locCon from '../LocalConstants'



function DashboardExhibitionFlippingCards() {

    const [currentIndex, setCurrentIndex] = useState(0)

    const simulationSteps = RefSimulationSteps()


    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % simulationSteps.length)
        }, locCon.EXHIBITION_FC_FREQUENCY * 1000);

        // Cleanup on unmount
        return () => clearInterval(intervalId);
    }, [simulationSteps]);



    return (
        <div style={{ backgroundColor: "white" }}>
            <div
                style={{
                    width: `100vw`,
                    height: `100vh`,
                    backgroundColor: "var(--exb-background-color)",
                }}
            >
                <DateTitle simulationSteps={simulationSteps} currentIndex={currentIndex} />
                <Space style={{ marginTop: "3vh" }}>
                    <OutdoorTemperatureProgressiveChart width="90vw" height="20vh" currentIndex={currentIndex} />
                </Space>
                <FlippingCardComponent rows={7} cols={10} width={99} height={68} currentIndex={currentIndex} />
            </div>
        </div>
    )

}

export default DashboardExhibitionFlippingCards